import axios from '@/api/$axios'
export default {
  list ({ page, perPage }) {
    return axios.get(`/teachers`, {
      params: { page, perPage }
    })
  },
  detail ({ teacherId }) {
    return axios.get(`/teachers/${teacherId}`)
  }
}
